export const GET_MA_TITLE = {
  init: function () {
    const titleTxt = document.getElementById('ma-title-txt')
    const pageTitle = document.getElementById('ma-pagetitle')

    const urlTxt = document.getElementById('ma-url-txt')
    const pageUrl = document.getElementById('ma-pageurl')

    if (titleTxt) {
      pageTitle.value = titleTxt.textContent
    }

    if (urlTxt) {
      pageUrl.value = urlTxt.textContent
    }

    // リファラ（参照元）のURLを取得
    const referrer = document.referrer

    // リファラが存在し、特定の条件に合致する場合にのみ実行
    if (referrer) {
      const referrerUrl = new URL(referrer)
      const referrerPath = referrerUrl.pathname

      // /contact/confirm からの遷移ではないことを確認
      if (
        referrerPath !== '/search/contact/confirm' &&
        referrerPath.startsWith('/search/project/')
      ) {
        setTimeout(function () {
          // no-storeとno-store02クラスを持つすべてのinputフィールドを取得
          const noStoreFields = document.querySelectorAll('input.no-store')
          const noStoreFields02 = document.querySelectorAll('input.no-store02')

          // 各inputフィールドを一度クリア
          noStoreFields.forEach(function (field) {
            field.value = ''
          })

          noStoreFields02.forEach(function (field) {
            field.value = ''
          })

          // 各inputフィールドにテキストを上書き
          noStoreFields.forEach(function (field) {
            field.value = titleTxt.textContent
          })
          noStoreFields02.forEach(function (field) {
            field.value = urlTxt.textContent
          })
        }, 100) // 100ミリ秒の遅延を追加して、フォームのロード完了を待つ
      }
    }
  },
}
